export const STATIC_SECTIONS = {
  homePage: [
    'advantages',
    'forWhatPurposesProvided',
    'conditionsTable',
    'howToIssueBusinessLoan',
    'faq',
    'information',
    'contactUs',
  ],
  landingPage: ['howToIssueBusinessLoan', 'contactUs'],
};

export default STATIC_SECTIONS;
